module.exports = __webpack_public_path__ + "img/p4-p1-molihua.de2c8809.png";